<div class="loaderContainer" *ngIf="showLoader">
    <div>
        <div class="lds-css ng-scope rotate">
            <div style="width:100%;height:100%">
                <img src="assets/lender/images/saarathi-loader.svg" style="max-width: 100%;" alt="loading...">
            </div>
        </div>
    </div>
</div>